<template>
  <el-card :body-style="{ padding: 0 }">
    <div slot="header" class="questionnaire header">
      <img
        src="../patient/card/image/questionnaire.png"
        style="margin-left:-3px"
      />
      <span>
        {{ questionnaireTitle }}
        <small>{{ questionnaireSubtitle }}</small>
      </span>
    </div>
    <div class="drop-filter">
      <el-select
        v-model="valueFirst"
        placeholder="Select Procedure List"
        size="small"
      >
        <el-option
          v-for="item in dropFirst"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="valueSecond"
        placeholder="Criteria 1 - Implants"
        size="small"
      >
        <el-option
          v-for="item in dropSecond"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="valueThird"
        placeholder="Criteria 2 - Biologics"
        size="small"
      >
        <el-option
          v-for="item in dropThird"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <div class="button-con">
        <el-button type="primary" plain size="small">
          Export Data
        </el-button>
        <el-button type="primary" plain size="small">
          Print / PDF
        </el-button>
      </div>
    </div>

    <!-- <QuestionnaireFilter v-model="filter"></QuestionnaireFilter> -->
    <div class="body">
      <transition name="slide-in" appear>
        <PatientList
          class="patient"
          v-if="showPatientList"
          v-bind:patient="userList"
          :question="questionObj"
          :questionnaire="questionnaire"
          @close="showPatientList = false"
        >
        </PatientList>
      </transition>
      <!-- <QuestionnaireStatistics
				v-bind:questionnaire="questionnaire"
				v-bind:parentFilter="filter"
				@patient-list="setPatientList">
			</QuestionnaireStatistics> -->

      <QuestionnaireViewer
        :questionnaire="questionnaire"
        :parentFilter="filter"
        @patient-list="setPatientList"
      >
      </QuestionnaireViewer>
    </div>
    <!--  -->
  </el-card>
</template>

<script>
import OutcomeMixin from "./mixin";
import QuestionnaireFilter from "./QuestionnaireFilter";
import QuestionnaireViewer from "./viewer/Viewer";
import QuestionnaireStatistics from "./QuestionnaireStatistics";
import PatientList from "./PatientList";
import { mapState } from "vuex";

export default {
  name: "outcome-questionnaire-card",

  mixins: [OutcomeMixin],

  data() {
    return {
      showPatientList: false,
      patientList: [],
      dropFirst: [
        "Laminectomy",
        "Laminoplasty",
        "Lumbar Decompression",
        "Anterior Cervical Discectomy and Fusion",
        "Anterior Cervical Corpectomy and Fusion",
        "Artificial Disk Replacement",
        "Lumbar Microdiscectomy",
        "Laminoforaminotomy",
        "Nucleoplasty",
        "Cervical Fusion",
        "Lumbar Fusion",
        "ALIF",
        "OLIF",
        "TLIF",
        "XLIF",
      ],
      dropSecond: [
        "Cages",
        "Hooks",
        "Plates",
        "Screws",
        "Rods",
        "Spinal cord stimulators",
      ],
      dropThird: [
        "Autograft",
        "Allograft",
        "Growth factor/peptide",
        "Synthetic",
      ],
      valueFirst: "",
      valueSecond: "",
      valueThird: "",
    };
  },

  watch: {
    userList: {
      immediate: true,
      handler(newUserList) {
        if (Array.isArray(newUserList) && newUserList.length > 0)
          this.showPatientList = true;
        else this.showPatientList = false;
      },
    },
  },

  computed: {
    ...mapState("outcome", ["userListObj"]),
    userList() {
      try {
        const flatUserList = this.userListObj.keyUserList.flatMap(
          ({ user }) => user
        );
        return flatUserList.filter(
          (user, userIndex) =>
            !flatUserList.some(
              (dupUser, dupIndex) =>
                dupIndex > userIndex && user.id === dupUser.id
            )
        );
      } catch (error) {
        console.error("Error in calculating userList ", error);
        return this.userListObj.keyUserList.flatMap(({ user }) => user);
      }
    },
    questionObj() {
      return this.questionnaireContent.question.find(
        ({ id, type, questions }) => {
          if (type === "multi_question" && Array.isArray(questions))
            return questions.some(
              ({ id }) => id === this.userListObj.questionId
            );
          return id === this.userListObj.questionId;
        }
      );
    },
    questionnaireSubtitle() {
      if (
        this.questionnaireTitle &&
        this.questionnaireTitle.toLowerCase().includes("questionnaire")
      )
        return "Analysis";
      return "Questionnaire Analysis";
    },
  },

  methods: {
    /**
     * Opens PatientList component for viewing repsonse list
     */
    setPatientList(patientList) {
      //this.patientList = patientList
      //this.showPatientList = true
    },
  },

  components: {
    QuestionnaireFilter,
    QuestionnaireViewer,
    QuestionnaireStatistics,
    PatientList,
  },
};
</script>

<style lang="scss" scoped>
@import "../patient/card/style.scss";
.el-card .header {
  padding-left: 40px;

  small {
    color: #7f7f7f;
    padding-left: 10px;
    font-weight: 400;
  }
}
.slide-in-enter {
  transform: translateX(200px);
}
.slide-in-enter-active {
  transition: transform 0.4s ease;
}
.slide-in-leave {
}
.slide-in-leave-active {
  transition: transform 0.4s ease;
  transform: translateX(200px);
}
.drop-filter {
  padding: 5px;
  display: flex;
  .el-select {
    padding-right: 5px;
  }
  .button-con {
    display: inline-block;
    text-align: right;
    flex-grow: 1;
  }
}
</style>
